import { UploadTempDocumentResponseErrorCode } from "../../../../data/dtos/upload-temp-document.dto";
import { UploadInvestorDocumentsResponseErrorCode } from "../../../../data/dtos/upload-investor-documents.dto";

export const DocumentStatuses = {
  PENDING: "pending",
  UPLOADED: "uploaded",
  ERROR: "error",
} as const;

export type DocumentStatus =
  (typeof DocumentStatuses)[keyof typeof DocumentStatuses];

export interface DocumentState {
  documentId?: string;
  documentType: string;
  file?: File;
  thumbnail?: string;
  fileName?: string;
  fileUrl?: string;
  index: number;
  status: DocumentStatus;
  errorType?:
    | UploadTempDocumentResponseErrorCode
    | UploadInvestorDocumentsResponseErrorCode;
  errorMessage?: string;
}
export interface TempDocument {
  documentType: string;
  fileName: string;
  fileType: string;
  url: string;
  file: File;
}
